import { BitkitLink, BitkitLinkProps, IconArrowNortheast } from '@bitrise/bitkit-v2';

import { PublicApiBuild } from '@/models/Build';
import BuildStatus from '@/models/BuildStatus';
import usePreviousSuccessfulBuild from '@/pages/BuildDetailsPage/hooks/usePreviousSuccessfulBuild';

interface LastSuccessfulBuildProps extends BitkitLinkProps {
  build: PublicApiBuild;
  isViewedAsPublicPage: boolean;
  projectSlug: string;
}

const LastSuccessfulBuild = (props: LastSuccessfulBuildProps) => {
  const { build, isViewedAsPublicPage, projectSlug, ...linkProps } = props;

  const { data, isError, isLoading } = usePreviousSuccessfulBuild(projectSlug, build, isViewedAsPublicPage);

  if (isError || isLoading || !data || !(!build.pipelineWorkflowId && build.status === BuildStatus.Error)) return null;

  return (
    <BitkitLink
      {...linkProps}
      colorVariant="purple"
      href={`/build/${data.slug}`}
      isExternal
      textStyle="body/md/regular"
      suffixIcon={IconArrowNortheast}
      suffixIconSize="16"
    >
      View last successful
    </BitkitLink>
  );
};

export default LastSuccessfulBuild;
